export const FOOTERMAPPING = () => {
  return {
    list: {
      "common": {
        "footer": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy",
              "link": "https://www.aig.com/global-privacy-policy"
            }
          ]
        }
      },
      "at": {
        "footer": {
          "links": [
            {
              "label": $localize`:@@footer.termsOfUse:Terms Of Use`,
              "header": "Terms Of Use",
              "link": $localize`:@@footer.termsofuselink:https://www.aig.co.at/terms-of-use-en`
            },
            {
              "label": $localize`:@@footer.privacy:Privacy`,
              "header": "Privacy",
              "link": $localize`:@@footer.privacylink:https://www.aig.lu/en/privacy`
            },
            {
              "label": $localize`:@@footer.cookiePolicy:Cookie Policy`,
              "link": `/cookie-policy/${window.location.pathname.split('/')[2]}/${window.location.pathname.split('/')[3]}`
            },
            {
              "label": $localize`:@@footer.notification:Notification of Obligations`,
              "header": "Notification",
              "action": "openNotificationModal"
            }
          ],
          "copyrightText": $localize`:@@footer.copyright:Copyright © 2026 American International Group, Inc. All rights reserved.`,
          "disclaimerText": $localize`:@@footer.disclaimer:American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange.`

        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
                "link":$localize`:@@footer.termsofuselink:https://www.aig.co.at/terms-of-use-en`
              },
            {
              "label": "Privacy Policy",
              "link": $localize`:@@footer.privacylink:https://www.aig.lu/en/privacy`
            }
          ]
        }
      },
      
      "sg": {
        "footer": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.sg/terms-of-use"
            },
            {
              "label": "Privacy",
              "link": "https://www.aig.sg/privacy"
            },
            {
              "label": "Legal Notice",
              "link": "https://www.aig.sg/legal-notice"
            },
            {
              "label": "Cookie Policy",
              "link": "/cookie-policy/sg/en"
            }
          ],
          "copyrightText": "Copyright © 2026 American International Group, Inc. All rights reserved.",
          "disclaimerText": "American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange."
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.sg/terms-of-use"
            },
            {
              "label": "Privacy Policy",
              "link": "https://www.aig.sg/privacy"
            }
          ]
        }
      },
      "au": {
        "footer": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com.au/terms-of-use"
            },
            {
              "label": "Privacy",
              "link": "https://www.aig.com.au/privacy-policy"
            },
            {
              "label": "Legal Notice",
              "link": "https://www.aig.com/legal-notice"
            },
            {
              "label": "Cookie Policy",
              "link": "/cookie-policy/au/en"
            }
          ],
          "copyrightText": "Copyright © 2026 American International Group, Inc. All rights reserved.",
          "disclaimerText": "American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange."
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com.au/terms-of-use"
            },
            {
              "label": "Privacy Policy",
              "link": "https://www.aig.com.au/privacy-policy"
            }
          ]
        }
      },
      "be": {
        "footer": {
          "links": [
            {
              "label": $localize`:@@footer.termsofuse:Terms Of Use`,
              "header": "Terms Of Use",
              "link": $localize`:@@footer.termsofuselink:https://www.aig.be/home/about-us/terms-of-use`
            },
            {
              "label": $localize`:@@footer.privacy:Privacy`,
              "header": "Privacy",
              "link": $localize`:@@footer.privacylink:https://www.aig.be/privacy`
            },
            {
              "label": $localize`:@@footer.legalnotice:Legal Notice`,
              "header": "Legal Notice",
              "link": $localize`:@@footer.legalnoticelink:https://www.aig.be/home/about-us/terms-of-use`
            },
            {
              "label": $localize`:@@footer.cookiePolicy:Cookie Policy`,
              "link": `/cookie-policy/${window.location.pathname.split('/')[2]}/${window.location.pathname.split('/')[3]}`
            }
          ],
          "copyrightText": $localize`:@@footer.copyright:Copyright © 2026 American International Group, Inc. All rights reserved.`,
          "disclaimerText": $localize`:@@footer.disclaimer:American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange.`
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.be/home/about-us/terms-of-use"
            },
            {
              "label": "Privacy Policy",
              "link": $localize`:@@footer.privacylink:https://www.aig.be/privacy`
            }
          ]
        }
      },
      "br": {
        "footer": {
        "links": [
            {
              "label": $localize`:@@footer.termsofuse:Terms Of Use`,
              "header": "Terms Of Use",
              "link": $localize`:@@footer.termsofuselink:"https://www.aig.com/terms-of-use`
            },
            {
              "label": $localize`:@@footer.privacy:Privacy`,
              "header": "Privacy",
              "link": $localize`:@@footer.privacylink:"https://www.aig.com.br/privacidade`
            },
            {
              "label": $localize`:@@footer.legalnotice:Legal Notice`,
              "header": "Legal Notice",
              "link": $localize`:@@footer.legalnoticelink:"https://www.aig.com/legal-notice`
            },
            {
              "label": $localize`:@@footer.cookiePolicy:Cookie Policy`,
              "link": `/cookie-policy/${window.location.pathname.split('/')[2]}/${window.location.pathname.split('/')[3]}`
            },
          ],
          "copyrightText": $localize`:@@footer.copyright:Copyright © 2026 American International Group, Inc. All rights reserved.`,
          "disclaimerText": $localize`:@@footer.disclaimer:American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange.`
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy Policy",
              "link": $localize`:@@footer.privacylink:https://www.aig.com.br/privacidade`
            }
          ]
        }
      },      
      "de": {
        "footer": {
          "links": [
            {
              "label": $localize`:@@footer.termsOfUse:Terms Of Use`,
              "header": "Terms Of Use",
              "link": $localize`:@@footer.termsofuselink:https://www.aig.de/terms-of-use-en`
            },
            {
              "label": $localize`:@@footer.privacy:Privacy`,
              "header": "Privacy",
              "link": $localize`:@@footer.privacylink:https://www.aig.lu/en/privacy`
            },
            {
              "label": $localize`:@@footer.cookiePolicy:Cookie Policy`,
              "link": `/cookie-policy/${window.location.pathname.split('/')[2]}/${window.location.pathname.split('/')[3]}`
            },
            {
              "label": $localize`:@@footer.notification:Notification of Obligations`,
              "header": "Notification",
              "action": "openNotificationModal"
            }
          ],
          "copyrightText": $localize`:@@footer.copyright:Copyright © 2026 American International Group, Inc. All rights reserved.`,
          "disclaimerText": $localize`:@@footer.disclaimer:American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange.`

        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": $localize`:@@footer.termsofuselink:https://www.aig.de/terms-of-use-en`
            },
            {
              "label": "Privacy Policy",
              "link": $localize`:@@footer.privacylink:https://www.aig.lu/en/privacy`
            }
          ]
        }
      },
      "ca": {
        "footer": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy",
              "link": "https://www.aig.ca/privacy-principles"
            },
            {
              "label": "Legal Notice",
              "link": "https://www.aig.com/legal-notice"
            },
            {
              "label": "Cookie Policy",
              "link": "/cookie-policy/ca/en"
            },
             {
              "label": "Contact Us",
              "link": "https://www.aig.ca/home/contact-aig#accordion-c6b2a29168-item-8d9548fd9e"
            }
          ],
          "copyrightText": "Copyright © 2026 American International Group, Inc. All rights reserved.",
          "disclaimerText": "American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange."
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy Policy",
              "link": " https://www.aig.ca/privacy-principles"
            }
          ]
        }
      },
      "ch": {
        "footer": {
          "links": [
            {
              "label": $localize`:@@footer.termsOfUse:Terms Of Use`,
              "header": "Terms Of Use",
              "link": $localize`:@@footer.termsofuselink:https://www.aig.ch/terms-of-use`
            },
            {
              "label": $localize`:@@footer.privacy:Privacy`,
              "header": "Privacy",
              "link": $localize`:@@footer.privacylink:https://www.aig.ch/privacy-policy-de`
            },
            {
              "label": $localize`:@@footer.cookiePolicy:Cookie Policy`,
              "link": `/cookie-policy/${window.location.pathname.split('/')[2]}/${window.location.pathname.split('/')[3]}`
            },
            {
              "label": $localize`:@@footer.notification:Notification of Obligations`,
              "header": "Notification",
              "action": "openNotificationModal"
            }
          ],
          "copyrightText": $localize`:@@footer.copyright:Copyright © 2026 American International Group, Inc. All rights reserved.`,
          "disclaimerText": $localize`:@@footer.disclaimer:American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange.`
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.ch/terms-of-use"
            },
            {
              "label": "Privacy Policy",
              "link": " https://www.aig.ch/privacy-policy-de"
            }
          ],
          "copyrightText": $localize`:@@footer.copyright:Copyright © 2026 American International Group, Inc. All rights reserved.`,
          "disclaimerText": $localize`:@@footer.disclaimer:American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange.`

        }
      },
      "fr": {
        "footer": {
          "links": [
            {
              "label": $localize`:@@footer.termsofuse:Terms Of Use`,
              "link": $localize`:@@footer.termsofuselink:https://www.aig.com/terms-of-use`
            },
            {
              "label": $localize`:@@footer.privacy:Privacy`,
              "link": $localize`:@@footer.privacylink:https://www.aig.lu/en/privacy`
            },
            {
              "label": $localize`:@@footer.legalnotice:Legal Notice`,
              "link": $localize`:@@footer.legalnoticelink:https://www.aig.com/legal-notice`
            },
            {
              "label": $localize`:@@footer.cookiePolicy:Cookie Policy`,
              "link": `/cookie-policy/${window.location.pathname.split('/')[2]}/${window.location.pathname.split('/')[3]}`
            }
          ],
          "copyrightText": $localize`:@@footer.copyright:Copyright © 2026 American International Group, Inc. All rights reserved.`,
          "disclaimerText": $localize`:@@footer.disclaimer:American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange.`
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy Policy",
              "link": $localize`:@@footer.privacylink:https://www.aig.lu/en/privacy`
            }
          ]
        }
      },
      "gb": {
        "footer": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy",
              "link": "https://www.aig.co.uk/privacy-policy"
            },
            {
              "label": "Legal Notice",
              "link": "https://www.aig.com/legal-notice"
            },
            {
              "label": "Cookie Policy",
              "link": "/cookie-policy/gb/en"
            }
          ],
          "copyrightText": "Copyright © 2026 American International Group, Inc. All rights reserved.",
          "disclaimerText": "American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange."
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy Policy",
              "link": "https://www.aig.co.uk/privacy-policy"
            }
          ]
        }
      },
      "hk": {
        "footer": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com.hk/terms-of-use"
            },
            {
              "label": "Privacy",
              "link": "https://www.aig.com.hk/privacy-policy"
            },
            {
              "label": "Legal Notice",
              "link": "https://www.aig.com/legal-notice"
            },
            {
              "label": "Cookie Policy",
              "link": "/cookie-policy/hk/en"
            }
          ],
          "copyrightText": "Copyright © 2026 American International Group, Inc. All rights reserved.",
          "disclaimerText": "American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange."
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com.hk/terms-of-use"
            },
            {
              "label": "Privacy Policy",
              "link": "https://www.aig.com.hk/privacy-policy"
            }
          ]
        }
      },
      "ie": {
        "footer": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy",
              "link": "https://www.aig.ie/privacy-policy"
            },
            {
              "label": "Legal Notice",
              "link": "https://www.aig.ie/terms-of-business"
            },
            {
              "label": "Cookie Policy",
              "link": "/cookie-policy/ie/en"
            }
          ],
          "copyrightText": "Copyright © 2026 American International Group, Inc. All rights reserved.",
          "disclaimerText": "American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange."
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy Policy",
              "link": "https://www.aig.ie/privacy-policy"
            }
          ]
        }
      },
      "mx": {
        "footer": {
          "links": [
            {
              "label": $localize`:@@footer.termsofuse:Terms Of Use`,
              "header": "Terms Of Use",
              "link": $localize`:@@footer.termsofuselink:"https://www.aig.com.mx/content/dam/aig/lac/mexico/documents/brochures/condiciones-de-uso-brochure.pdf"`
            },
            {
              "label": $localize`:@@footer.privacy:Privacy`,
              "header": "Privacy",
              "link": "https://www.aig.com.mx/content/dam/aig/lac/mexico/documents/documentos_2025/aviso_de_privacidad_integral_aigmexico_mayo2025.pdf"
            },
            {
              "label": $localize`:@@footer.legalnotice:Legal Notice`,
              "header": "Legal Notice",
              "link": "https://www.aig.com/legal-notice"
            },            
            {
              "label": $localize`:@@footer.cookiePolicy:Cookie Policy`,
              "link": `/cookie-policy/${window.location.pathname.split('/')[2]}/${window.location.pathname.split('/')[3]}`
            }
          ],
          "copyrightText": $localize`:@@footer.copyright:Copyright © 2026 American International Group, Inc. All rights reserved.`,
          "disclaimerText": $localize`:@@footer.disclaimer:American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange.`        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com.mx/content/dam/aig/lac/mexico/documents/brochures/condiciones-de-uso-brochure.pdf"
            },
            {
              "label": "Privacy Policy",
              "link": "https://www.aig.com.mx/content/dam/aig/lac/mexico/documents/documentos_2025/aviso_de_privacidad_integral_aigmexico_mayo2025.pdf"
            }
          ]
        }
      },
      "my": {
        "footer": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy",
              "link": "https://www.aig.my/privacy-notice"
            },
            {
              "label": "Legal Notice",
              "link": "https://www.aig.com/legal-notice"
            },
            {
              "label": "Cookie Policy",
              "link": "/cookie-policy/my/en"
            },
          ],
          "copyrightText": "Copyright © 2026 American International Group, Inc. All rights reserved.",
          "disclaimerText": "American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange."
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy Policy",
              "link": "https://www.aig.my/privacy-notice"
            }
          ]
        }
      },
"nl": {
        "footer": {
          "links": [
            {
              "label": "Gebruiksvoorwaarden",
              "link": "https://www.aiginsurance.nl/wettelijke-informatie-en-gebruiksvoorwaarden"
            },
            {
              "label": "Privacy",
              "link": "https://www.aiginsurance.nl/privacybeleid"
            },
            {
              "label": "Juridische kennisgeving",
              "link": "https://www.aiginsurance.nl/wettelijke-informatie-en-gebruiksvoorwaarden"
            },
            {
              "label": "Cookiebeleid",
              "link": "/cookie-policy/nl/nl"
            }
          ],
          "copyrightText": "Copyright © 2026 American International Group, Inc. Alle rechten voorbehouden.",
          "disclaimerText": "American International Group, Inc. (AIG) is een toonaangevende wereldwijde verzekeringsorganisatie. Bedrijven die lid zijn van AIG bieden verzekeringsoplossingen waarmee bedrijven en particulieren in ongeveer 70 landen en rechtsgebieden hun bezittingen kunnen beschermen en risico's kunnen beheren. De gewone aandelen AIG zijn genoteerd aan de New York Stock Exchange."
        },
        "privacy": {
          "links": [
            {
              "label": "Gebruiksvoorwaarden",
              "link": "https://www.aiginsurance.nl/wettelijke-informatie-en-gebruiksvoorwaarden"
            },
            {
              "label": "Privacy Beleid",
              "link": "https://www.aiginsurance.nl/privacybeleid"
            }
          ]
        }
      },
      "nz": {
        "footer": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.co.nz/terms-of-use"
            },
            {
              "label": "Privacy",
              "link": "https://www.aig.co.nz/privacy-policy"
            },
            {
              "label": "Legal Notice",
              "link": "https://www.aig.com/legal-notice"
            },
            {
              "label": "Cookie Policy",
              "link": "/cookie-policy/nz/en"
            },
          ],
          "copyrightText": "Copyright © 2026 American International Group, Inc. All rights reserved.",
          "disclaimerText": "American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange."
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.co.nz/terms-of-use"
            },
            {
              "label": "Privacy Policy",
              "link": "https://www.aig.co.nz/privacy-policy"
            }
          ]
        }
      },
      "es": {
        "footer": {
          "links": [
            {
              "label": "Condiciones De Uso",
              "link": "https://www.aig.com.es/condiciones-de-uso"
            },
            {
              "label": "Privacidad",
              "link": "https://www.aig.com.es/politica-de-privacidad"
            },
            {
              "label": "Aviso Legal",
              "link": "https://www.aig.com/legal-notice"
            },
            {
              "label": "Política de Cookies",
              "link": "/cookie-policy/es/es"
            },
          ],
          "copyrightText": "Copyright © 2026 American International Group, Inc. Todos los derechos reservados.",
          "disclaimerText": "American International Group, Inc. (AIG) es una organización global líder en seguros. Las compañías miembros de AIG ofrecen soluciones de seguros que ayudan a empresas y particulares en aproximadamente 70 países y jurisdicciones a proteger sus activos y gestionar riesgos. Las acciones habituales de AIG cotizan en la Bolsa de Valores de Nueva York."
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com.es/condiciones-de-uso"
            },
            {
              "label": "Privacy Policy",
              "link": "https://www.aig.com.es/politica-de-privacidad"
            }
          ]
        }
      },
      "pt": {
        "footer": {
          "links": [
            {
              "label": "Termos de utilização",
              "link": "https://www.aig.com.pt/termos-e-condicoes"
            },
            {
              "label": "Privacidade",
              "link": "https://www.aig.com.pt/privacy-policy"
            },
            {
              "label": "Aviso legal",
              "link": "https://www.aig.com.pt/termos-e-condicoes"
            },
            {
              "label": $localize`:@@footer.cookiePolicy:Cookie Policy`,
              "link": `/cookie-policy/pt/pt`
            },
          ],
          "copyrightText": "Copyright © 2026 American International Group, Inc. Todos os direitos reservados.",
          "disclaimerText": "A American International Group, Inc. (AIG) é uma organização líder global de seguros. As empresas associadas à AIG oferecem soluções de seguros que ajudam empresas e particulares em aproximadamente 70 países e jurisdições a proteger os seus ativos e a gerir riscos. As ações ordinárias da AIG estão cotadas na Bolsa de Nova Iorque."
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com.pt/termos-e-condicoes"
            },
            {
              "label": "Privacy Policy",
              "link": "https://www.aig.com.pt/privacy-policy"
            }
          ]
        }
      },
      "us": {
        "footer": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy",
              "link": "https://www.aig.com/privacy-policy"
            },
            {
              "label": "Legal Notice",
              "link": "https://www.aig.com/legal-notice"
            },
            {
              "label": "Fraud Warning",
              "link": "https://www.aig.com/fraud-warning"
            },
            {
              "label": "Cookie Policy",
              "link": "https://www.aig.com/cookie-policy"
            },
            
             {
              "label": "Contact Us",
              "link": "https://www.aig.com/home/contact#accordion-6150612a1e-item-287db3e010"
            }
          ],
          "copyrightText": "Copyright © 2026 American International Group, Inc. All rights reserved.",
          "disclaimerText": "American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange."
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy Policy",
              "link": "https://www.aig.com/privacy-policy"
            }
          ]
        }
      },
      "za": {
        "footer": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy",
              "link": "https://www.aig.co.za/privacy-policy"
            },
            {
              "label": "Legal Notice",
              "link": "https://www.aig.com/legal-notice"
            },
            {
              "label": "Cookie Policy",
              "link": "/cookie-policy/za/en"
            }
          ],
          "copyrightText": "Copyright © 2026 American International Group, Inc. All rights reserved.",
          "disclaimerText": "American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange."
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com/terms-of-use"
            },
            {
              "label": "Privacy Policy",
              "link": "https://www.aig.co.za/privacy-policy"
            }
          ]
        }
      },
      "ec": {
        "footer": {
          "links": [
            {
              "label": $localize`:@@footer.termsofuse:Terms Of Use`,
              "link": $localize`:@@footer.termsofuselink:https://www.aig.com.ec/terminos-condiciones`
            },
            {
              "label": $localize`:@@footer.privacy:Privacy`,
              "link": $localize`:@@footer.privacylink:https://www.aig.com.ec/privacidad`
            },
            {
              "label": $localize`:@@footer.legalnotice:Legal Notice`,
              "link": $localize`:@@footer.legalnoticelink:https://www.aig.com/legal-notice`
            },
            {
              "label": $localize`:@@footer.cookiePolicy:Cookie Policy`,
              "link": `/cookie-policy/${window.location.pathname.split('/')[2]}/${window.location.pathname.split('/')[3]}`
            }
          ],
          "copyrightText": $localize`:@@footer.copyright:Copyright © 2026 American International Group, Inc. All rights reserved.`,
          "disclaimerText": $localize`:@@footer.disclaimer:American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange.`
        },
        "privacy": {
          "links": [
            {
              "label": "Terms Of Use",
              "link": "https://www.aig.com.ec/terminos-condiciones"
            },
            {
              "label": "Privacy Policy",
              "link": "https://www.aig.com.ec/privacidad"
            }
          ]
        }
      },
    }
  }
}
